import { createAsyncThunk } from "@reduxjs/toolkit";
import NotifyConfig from "../../utils/NotifyConfig";
import AuthService from "../services/authService";

export const LoginThunk = createAsyncThunk("auth/Login", async (info) => {
  try {
    const response = await AuthService.login(info.data);

    return response;
  } catch (err) {
    NotifyConfig.notifyErrorServer(err.response?.data?.error?.text);
    console.error(err);
  }
});
